<template>
  <div id="page_content" class="page_content">
    <slot name="pc"></slot>
  </div>
</template>

<script>
  export default {
    name: "PageContent"
  }
</script>

<style lang="less">
  .page_content {
    * {
      margin: 0;
      padding: 0;
    }
    padding-top: 4.167vw;
    .page_list {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding-bottom: 6.25em;
      .pl_title {
        font-size: 1.25em;
        font-weight: bold;
        width: 24.009vw;
        p {
          span {
            border-bottom: solid thin black;
          }
          &:last-child {
            span {
              border-bottom: none;
            }
          }
        }
      }
      .pl_content {
        font-size: 0.875em;
        width: 53.074vw;
        p {
          strong {
            margin-right: 2em;
          }
        }
        img {
          width: 100%;
        }
        .plc_title {
          font-weight: bold;
          line-height: 1.536;
          margin-bottom: 1.419vw;
          p {
            margin: 0;
          }
        }
        .plc_content {
          font-size: 0.875em;
        }

        .plc_title_18 {
          font-size: 1.125em;
        }
        .plc_title_24 {
          font-size: 1.5em;
        }
        .plc_title_32 {
          font-size: 2em;
        }
        .plc_title_36 {
          font-size: 2.25em;
        }
      }
      .border_top {
        border-top: solid thin rgba(0,0,0,0.85);
      }
    }
    .ad {
      display: block;
      width: 100vw;
      position: relative;
      z-index: 1;
      left: -15%;
      background-color: black;
      img {
        display: block;
        width: 100%;
        position: relative;
        z-index: 1;
      }
      .ad_page_content {
        width: 77.1vw;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 11.45vw;
        color: white;
        padding-top: 2.5em;
        .pl_title {
          p {
            span {
              border-bottom: solid thin white;
            }
            &:last-child {
              span {
                border-bottom: none;
              }
            }
          }
        }
      }
    }
    .mb_100 {
      margin-bottom: 5.208vw;
    }
    .mb_60 {
      margin-bottom: 3.125vw;
    }
    .mb_40 {
      margin-bottom: 2.083vw;
    }
    .ptb_40 {
      padding: 2.083vw 0;
    }
    .ptb_80 {
      padding: 4.166vw 0;
    }
    .ptb_20_40 {
      padding: 1.042vw 0 2.083vw 0;
    }
    .pb_80 {
      padding-bottom: 4.167vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/PageContent.vue